import axios from "axios";
import { API_BASE_URL } from "../../config";

const getAuthHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("cms_token")}`,
});

export const fetchDemoBookings = async (params = {}) => {
  const res = await axios.get(`${API_BASE_URL}/demo-bookings`, {
    params,
    headers: getAuthHeaders(),
  });
  return res.data;
};

export const fetchDemoBookingDetail = async (leadId) => {
  const res = await axios.get(`${API_BASE_URL}/demo-bookings/${leadId}`, {
    headers: getAuthHeaders(),
  });
  return res.data;
};

export const updateDemoStatus = async (payload) => {
  const res = await axios.post(`${API_BASE_URL}/update-demo-status`, payload, {
    headers: { ...getAuthHeaders(), "Content-Type": "application/json" },
  });
  return res.data;
};

export const rescheduleDemo = async (payload) => {
  const body = {
    lead_id:   payload.lead_id,
    demo_date: payload.demo_date,   // YYYY-MM-DD HH:mm:ss
    demo_mode: payload.demo_mode,
    // Lead status value comes from /lead-follow-up-options ("Meeting Scheduled").
    // Omitted when the option can't be resolved, so the backend just skips it.
    ...(payload.status != null && payload.status !== "" ? { status: payload.status } : {}),
    // Only sent for video demos — backend stores it and adds a "Join Video
    // Meeting" button to the reschedule email.
    ...(payload.meeting_link ? { meeting_link: payload.meeting_link } : {}),
    ...(payload.remarks ? { remarks: payload.remarks } : {}),
  };
  const res = await axios.post(`${API_BASE_URL}/reschedule-demo`, body, {
    headers: { ...getAuthHeaders(), "Content-Type": "application/json" },
  });
  return res.data;
};

export const addFollowUp = async (payload) => {
  const hasFile = payload.attachments?.length > 0;
  if (hasFile) {
    const fd = new FormData();
    Object.entries(payload).forEach(([k, v]) => {
      if (k === "attachments") v.forEach((f) => fd.append("attachments[]", f));
      else if (v != null) fd.append(k, v);
    });
    const res = await axios.post(`${API_BASE_URL}/lead-followups`, fd, {
      headers: { ...getAuthHeaders(), "Content-Type": "multipart/form-data" },
    });
    return res.data;
  }
  const res = await axios.post(`${API_BASE_URL}/lead-followups`, payload, {
    headers: { ...getAuthHeaders(), "Content-Type": "application/json" },
  });
  return res.data;
};

export const fetchFollowUps = async (leadId) => {
  const res = await axios.get(`${API_BASE_URL}/lead-followups`, {
    params: { lead_id: leadId, limit: 100 },
    headers: getAuthHeaders(),
  });
  return res.data?.data || [];
};

export const fetchFollowUpOptions = async () => {
  const res = await axios.get(`${API_BASE_URL}/lead-follow-up-options`, {
    headers: getAuthHeaders(),
  });
  return res.data?.data || [];
};

export const updateLeadStage = async ({ leadId, stage }) => {
  const res = await axios.put(`${API_BASE_URL}/leads/${leadId}/stage`, { stage }, {
    headers: { ...getAuthHeaders(), "Content-Type": "application/json" },
  });
  return res.data;
};
